export const GET_CORPUSE_REQ = 'GET_CORPUSE_REQ';
export const GET_CORPUSE_OK = 'GET_CORPUSE_OK';

export const GET_CORPUSE_DOCUMENT_REQ = 'GET_CORPUSE_DOCUMENT_REQ';
export const GET_CORPUSE_DOCUMENT_OK = 'GET_CORPUSE_DOCUMENT_OK';

export const CLEAR_CORPUS_INFO_REQ = 'CLEAR_CORPUS_INFO_REQ';

export const SEARCH_BY_CORPUSE_REQ = 'SEARCH_BY_CORPUSE_REQ';
export const SEARCH_BY_CORPUSE_OK = 'SEARCH_BY_CORPUSE_OK';
export const SEARCH_BY_CORPUSE_ERR = 'SEARCH_BY_CORPUSE_ERR';

export const CLEAR_CORPUS_SEARCH_REQ = 'CLEAR_CORPUS_SEARCH_REQ';
export const CLEAR_CORPUS_SEARCH_OK = 'CLEAR_CORPUS_SEARCH_OK';

export const SELECT_CORPUS_DOCUMENT_REQ = 'SELECT_CORPUS_DOCUMENT_REQ';
export const SELECT_CORPUS_DOCUMENT_OK = 'SELECT_CORPUS_DOCUMENT_OK';

export const SELECT_CORPUS_DOCUMENT_IN_SEARCH_REQ = 'SELECT_CORPUS_DOCUMENT_IN_SEARCH_REQ';
export const SELECT_CORPUS_DOCUMENT_IN_SEARCH_OK = 'SELECT_CORPUS_DOCUMENT_IN_SEARCH_OK';